module.exports = __webpack_public_path__ + "static/media/sostenibilidad2022.ac826ba6.pdf";